import { useParams, useNavigate } from 'react-router-dom';
import { Button } from '@/components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/Card';

export function FinishPage() {
  const { token } = useParams<{ token: string }>();
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen items-center justify-center bg-muted/30 p-4">
      <Card className="max-w-md">
        <CardHeader>
          <CardTitle>Evaluación enviada</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          <p className="text-sm text-muted-foreground">
            Tus respuestas han sido registradas correctamente. El área de Recursos Humanos recibirá
            la información para el proceso de selección. No se muestran resultados al candidato.
          </p>
          <Button onClick={() => navigate(`/c/${token}/thanks`)}>Continuar</Button>
        </CardContent>
      </Card>
    </div>
  );
}
